import { ContactNotificationType } from './contact-notification-type';

export interface Contact {
  contactId: number;
  firstName: string;
  lastName: string;
  emailAddress: string;
  prefix: string;
  contactNotificationTypeId: number;
}

export function copyContact(contact: Contact): Contact {
  return {
    contactId: contact.contactId,
    emailAddress: contact.emailAddress,
    firstName: contact.firstName,
    lastName: contact.lastName,
    prefix: contact.prefix,
    contactNotificationTypeId: contact.contactNotificationTypeId,
  }
}

export function blankContact(): Contact {
  return {
    contactId: 0,
    firstName: '',
    lastName: '',
    emailAddress: '',
    prefix: '',
    contactNotificationTypeId: ContactNotificationType.AllNotifications,
  };
}
